import Box from '@mui/material/Box';
import React, { useEffect, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import ListNotification from '../Notification/ListNotification'
import ListActivities from '../Notification/ListActivities';
import { Badge } from '@mui/material';
import { API } from '../../API';

const LIMIT = 20;
const NOTIFICATION_TYPE = 'notification';
const ACTIVITY_TYPE = "activity"


export default function NotificationIcon({ role }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedTab, setSelectedTab] = useState(0);
  const [notifications, setNotifications] = useState([])
  const [activities, setActivities] = useState([])
  const [unreadNotificationsNumber, setUnreadNotificationsNumber] = useState(0)
  const [unreadActivitiesNumber, setUnreadActivitiesNumber] = useState(0)
  const totalUnreadNotifications = unreadNotificationsNumber + unreadActivitiesNumber

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleRedirect = (noti) => {
    const redirectPath = noti?.redirect_path
    if (redirectPath) {
      window.location = redirectPath
    }
  }

  const fetchNotificationData = () => {
    if (role !== "teacher") {
      API.getListNotifications(LIMIT, 1, NOTIFICATION_TYPE)
        .then((response) => {
          setNotifications(response?.data?.data?.data || []);
          setUnreadNotificationsNumber(response?.data?.data?.unread_count || 0)
        })
        .catch((error) => {
          console.log(`error`, error);
        })
    } else {
      API.getListTeacherNotifications(LIMIT, 1, NOTIFICATION_TYPE)
        .then((response) => {
          setNotifications(response?.data?.data?.data || []);
          setUnreadNotificationsNumber(response?.data?.data?.unread_count || 0)
        })
        .catch((error) => {
          console.log(`error`, error);
        })
    }
  };

  const fetchActivityData = () => {
    if (role !== "teacher") {
      API.getListNotifications(LIMIT, 1, ACTIVITY_TYPE)
        .then((response) => {
          setActivities(response?.data?.data?.data || []);
          setUnreadActivitiesNumber(response?.data?.data?.unread_count || 0)
        })
        .catch((error) => {
          console.log(`error`, error);
        })
    } else {
      API.getListTeacherNotifications(LIMIT, 1, ACTIVITY_TYPE)
        .then((response) => {
          setActivities(response?.data?.data?.data || []);
          setUnreadActivitiesNumber(response?.data?.data?.unread_count || 0)
        })
        .catch((error) => {
          console.log(`error`, error);
        })
    }
  };

  useEffect(() => {
    fetchNotificationData()
    fetchActivityData()
  }, [])

  return (
    <div>
      <Box className="noti-icon-container" sx={{color: 'white', cursor: "pointer"}}>
        <Badge color="primary" badgeContent={totalUnreadNotifications.toString()} className="badge-noti-icon">
          <IconButton className="noti-icon-button" sx={{color: "white"}} onClick={handleClick} aria-describedby={id}>
            <NotificationsIcon color="white"/>
          </IconButton>
        </Badge>
      </Box>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        sx={{marginTop: "5px"}}
      >
        <Tabs value={selectedTab} onChange={handleTabChange} variant="fullWidth" className="noti-tab">
          <Tab
            label={
              <Badge 
                badgeContent={unreadNotificationsNumber.toString()}
                color="primary"
                className="badge-tab"
              >
                Notifications
              </Badge>
            }
            className={selectedTab === 0 ? "active-noti-tab-item": "inactive-noti-tab-item" }
          />
          <Tab
            label={
              <Badge
                badgeContent={unreadActivitiesNumber.toString()}
                color="primary"
                className="badge-tab"
              >
                Activities
              </Badge>
            }
            className={selectedTab === 1 ? "active-noti-tab-item": "inactive-noti-tab-item" }
          />
        </Tabs>
        {selectedTab === 0 && (
          <ListNotification
            notifications={notifications}
            setNotifications={setNotifications}
            handleRedirect={handleRedirect}
            setUnreadNotificationsNumber={setUnreadNotificationsNumber}
            role={role}
          />
        )}
        {selectedTab === 1 && (
          <ListActivities
            activities={activities}
            setActivities={setActivities}
            handleRedirect={handleRedirect}
            setUnreadActivitiesNumber={setUnreadActivitiesNumber}
            role={role}
          />
        )}
      </Popover>
    </div>
  );
}
